import base from 'stores/search-base/actions';
import { cloneObject } from 'utils';
import * as types from './mutation-types';
import FormulationRepositoryService from '../../services/FormulationRepositoryService';

export default {
  ...base,
  async search({
    getters, commit, dispatch
  }) {
    dispatch('setLoadingState', true);
    commit(
      types.SET_RESULTS,
      await FormulationRepositoryService.search(
        getters.urlFilters,
        getters['user/token'],
        { includeProductSuggestions: true }
      )
    );
    dispatch('setLoadingState', false);
  },
  async loadMore({ getters, commit, dispatch }) {
    dispatch('setLoadingState', true);
    const result = await FormulationRepositoryService.loadMore(getters.results.hits.length, getters['user/token']);
    if (result && result.hits) {
      commit(types.ADD_RESULTS, result.hits);
    }
    dispatch('setLoadingState', false);
  },
  setTab({ state, getters, dispatch }, tab) {
    if (state.availableTabs.indexOf(tab) > -1 && getters.activeTab !== tab) {
      const urlFilters = cloneObject(getters.urlFilters);
      urlFilters.tab = tab;
      dispatch('setUrlFilters', urlFilters);
    }
  },
  updateResultRow({ commit }, { id, data }) {
    if (id && data) {
      commit(types.UPDATE_RESULT_ROW, {
        id,
        data
      });
    }
  }
};
